import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bird = defineConnector({
  identifier: "bird",
  name: "Bird",
  tagLine: "Customer communications platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://[^/]*\\.bird\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "authorization",
        value: app.secret.apiKey,
        scheme: "AccessKey",
      },
    ]),
  steps: [
    {
      title: "Find your Bird API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Bird authentication docs](https://docs.bird.com/api/authentication) and create or copy an API key from your Bird developer settings. Use a key from the workspace that owns the messaging resources you want to access.",
        },
      ],
    },
    {
      title: "Connect your Bird account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Bird instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Subdomain",
          placeholder: "api",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The subdomain of your Bird API instance (e.g. https://api.bird.com)",
        },
        {
          kind: "input",
          label: "Workspaces Id",
          placeholder: "332bb273-0caf-4240-a5b6-8046b5d3074f",
          required: true,
          target: { kind: "configuration", field: "workspaceId" },
          helperText: "The  Workspaces Id of your Bird",
        },
        {
          kind: "input",
          label: "Access Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "6BPC******************Rzh3F4x",
          helperText: "Your Bird access key",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) => `https://${configuration.subdomain}.bird.com/`,
  },
  publicEnvVars: ({ subdomain, workspaceId }) => ({
    BIRD_URL: subdomain ? `https://${subdomain}.bird.com` : "",
    BIRD_WORKSPACE_ID: workspaceId || "",
  }),
});
